export default "__VITE_ASSET__Dp36cS7r__"